import API from "./API";

let orgID = process.env.REACT_APP_ORGANIZATION_ID

export default class OrganizationDAO {
    static getSelf = async () => {
        return await API.request(`/v1/organization/${orgID}`, "GET");
    }
}